import { Box, BoxProps } from "@mui/material";
import React from "react";
import { NAV_WIDTH } from "../../constants/Layout";

interface FixedBottomAreaProps extends BoxProps {
  children: React.ReactNode;
}

export const FixedBottomArea: React.FC<FixedBottomAreaProps> = ({ children, sx, ...props }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: `${NAV_WIDTH}px`,
        right: 0,
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
        boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
        zIndex: 1000,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};